import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Mentionable } from '@src/components/sco/RichMarkdownInput/plugins/mentions';
import { ScoUserMentionOption } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useEffect, useState } from 'react';
export default function useUserMentionOptions(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fullName: t2,
    pageSize: t3
  } = t1;
  const fullName = t2 === undefined ? null : t2;
  const pageSize = t3 === undefined ? null : t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [mentionables, setMentionables] = useState(t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = gql`
      query ($fullName: String, $pageSize: Int) {
        scoUserMentionOptions(fullName: $fullName, pageSize: $pageSize) {
          id
          email
          fullName
          identifier
          label
          pictureUrl
          userId
        }
      }
    `;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== fullName || $[5] !== pageSize) {
    t6 = {
      ssr: false,
      variables: {
        fullName,
        pageSize
      }
    };
    $[4] = fullName;
    $[5] = pageSize;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const query = useQuery(t5, t6);
  let t7;
  if ($[7] !== query.data?.scoUserMentionOptions) {
    t7 = () => {
      if (query.data?.scoUserMentionOptions) {
        setMentionables(query.data?.scoUserMentionOptions);
      }
    };
    $[7] = query.data?.scoUserMentionOptions;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = query.data?.scoUserMentionOptions;
  let t9;
  if ($[9] !== t8) {
    t9 = [t8];
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  useEffect(t7, t9);
  let t10;
  if ($[11] !== mentionables || $[12] !== query) {
    t10 = {
      mentionables,
      query
    };
    $[11] = mentionables;
    $[12] = query;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
}